import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        lng: localStorage.getItem('i18nextLng') || 'hy',
        fallbackLng: 'hy',
        detection: {
            order: ['localStorage', 'cookie', 'htmlTag', 'subdomain'],
            caches: ['localStorage', 'cookie'],
        },
        interpolation: {
            escapeValue: false,
        },
        resources: {
            ru: {
                translation: {
                    header:{
                        home:'Главная',
                        tests:'Тесты',
                        wrongs:'Неправильные ответы',
                        grouped_questions:'Категории вопросов',
                        learn_rules: 'Обучение правилам',
                        traffic_signs: 'Дорожные знаки',
                        favorites: 'Избранные вопросы',
                        psycho: 'Психологические тесты',
                        search: 'Поиск вопросов',
                        search_placeholder: 'Поиск вопроса...',
                        educational: 'Обучение',
                        my_results: 'Мои результаты',
                        exam_tests: 'Экзаменационные тесты',
                        answer_title: 'Ответ на вопрос',
                        educational: 'Обучение',
                        my_results: 'Мои результаты'
                    },
                    home: {
                        welcome_text: 'Добро пожаловать AvtoDas.am',
                        description:"AvtoDas.am включает в себя все вопросы теоретического теста для получения водительских прав, совершенно бесплатно. Здесь вы можете ознакомиться с тестами, ответить на заданные вопросы, а затем, увидев результаты, еще раз ответить на неправильно отвеченные вопросы, что поможет закрепить правильные ответы.На сайте также есть список вопросов, сгруппированных по темам. После прохождения тестов обратите особое внимание на данные пояснения.",
                        results:"Статистика",
                        questions_count:'Количество вопросов',
                        answered:'Ответили',
                        true_answers:'Правильные ответы',
                        wrong_answers:'Неправильные ответы',
                        answer:'Отвечать',
                        not_answered:'Вопросы без ответов',
                        see_answer_end:'Смотреть результат в конце',
                        see_answer_end_desc:'После ответа на вопрос автоматически переходить к следующему и смотреть результаты в конце',
                        site_lang:'Язык веб-сайта',
                        site_lang_desc: 'Армянский / Русский',
                        settings:'Настройки',
                        learn_rules_title: 'Изучите самые важные правила',
                        learn_rules_desc: 'Мы выделили самые важные правила дорожного движения, которые помогут вам легче сдать экзамен и стать опытным водителем.',
                        start_learning: 'Начать обучение',
                        next_quiz: 'Следующий тест',
                        continue_quiz: 'Продолжить тест №{{number}}',
                        progress: 'Ваш прогресс',
                        passed_quizzes: 'Пройденные тесты',
                        no_passed_quizzes: 'Вы еще не прошли ни одного теста.',
                        hello: 'Привет',
                        years_old: 'лет',
                        change_info: 'Изменить данные',
                        faq_title: 'Часто задаваемые вопросы (FAQ)',
                        contact_us: 'Обратная связь:',
                        clear: 'Очистить',
                        clear_wrongs_title: 'Неправильные ответы',
                        clear_wrongs_desc: 'Очистить все неправильные ответы',
                        clear_results_title: 'Очистить результаты',
                        clear_results_desc: 'Очистить результаты всех пройденных тестов',
                        confirm_clear_wrongs: 'Все неправильные ответы будут считаться правильными, вы уверены?',
                        confirm_clear_results: 'Все результаты будут очищены, вы уверены?',
                        yes: 'Да',
                        no: 'Нет',
                        about: 'О нас',
                        privacy: 'Конфиденциальность',
                        terms: 'Условия',
                        created_by: 'Создано AvtoDas',
                        wall_of_fame: 'Доска почета',
                        recently_passed: 'Недавно сдали экзамен',
                        passed_with_score: 'Сдал с результатом {{score}}/20'
                    },
                    wrongs:{
                        desc_1:'Здесь вы можете решать вопросы, на которые вы ответили неправильно',
                        desc_2:'Неправильные ответы - {{count}}',
                        clear_all_confirm: 'Очистить все ошибки?',
                        clear_all_btn: 'Очистить все',
                        shuffle: 'Перемешать',
                        loading: 'Загрузка...',
                        congrats_no_wrongs: 'Поздравляем!',
                        no_wrongs_desc: 'У вас нет неправильно отвеченных вопросов. Вы готовы к экзамену!',
                        random_question: 'Случайный вопрос'
                    },
                    questions:{
                        see_description:'Посмотреть объяснение',
                        next:'Следующий',
                        tests:'Тесты',
                        true_answers_count:'Количество правильных ответов {{count}}/20',
                        difficulty:'Сложность',
                        congrats: 'Поздравляем!',
                        try_again: 'Попробуйте еще раз',
                        passed_desc: 'Вы успешно прошли этот тест!',
                        failed_desc: 'К сожалению, вы не прошли тест. Нужно минимум 18 правильных ответов.',
                        back_to_list: 'К списку тестов',
                        review_answers: 'Проверить ответы',
                        suggest_description: 'Предложить новое описание',
                        write_armenian_letters: 'Писать описание на армянском',
                        dont_forget_nation: 'Чтобы народ вас не забыл!!!',
                        description_label: 'Описание',
                        field_required: 'Поле обязательно для заполнения',
                        suggestion_success: 'Ваша запись будет проверена администратором и добавлена. НАРОД ВАС НЕ ЗАБУДЕТ',
                        remove_favorites: 'Удалить из избранного',
                        add_favorites: 'Добавить в избранное'
                    },
                    search: {
                        found_count: 'Найдено вопросов: {{count}}',
                        not_found: 'Вопросы не найдены.'
                    },
                    comments: {
                        title: 'Комментарии',
                        name: 'Ваше имя',
                        content: 'Ваш комментарий',
                        submit: 'Отправить',
                        placeholder_name: 'Введите ваше имя',
                        placeholder_content: 'Напишите комментарий...',
                        success: 'Ваш комментарий успешно добавлен!',
                        error_duplicate: 'Вы уже отправляли этот комментарий.',
                        error_spam: 'Пожалуйста, подождите перед отправкой нового комментария.',
                    },
                    quiz_filter: {
                        all: 'Все',
                        passed: 'Пройденные',
                        failed: 'Неудачные',
                        not_started: 'Не начатые',
                        new: 'Новый',
                    },
                    categories: {
                        questions_count: 'Вопросов: {{count}}',
                        description: 'Изучайте вопросы по конкретным темам, чтобы закрепить свои знания'
                    },
                    seo: {
                        home_title: 'AvtoDas - Теоретический экзамен по ПДД Армении 2026',
                        home_desc: 'Бесплатные онлайн тесты для получения водительских прав в Армении. Все 1200 вопросов с пояснениями, изучение знаков и правил дорожного движения.',
                        quizes_title: 'Список всех тестов ПДД - AvtoDas',
                        quizes_desc: 'Все 60 билетов официального теоретического экзамена для водителей. Практикуйтесь онлайн бесплатно.',
                        quiz_title: 'Тест №{{number}} - Экзамен ПДД Армении',
                        quiz_desc: 'Пройдите онлайн тест №{{number}} для подготовки к экзамену на права. Проверьте свои знания правил дорожного движения.',
                        wrongs_title: 'Работа над ошибками - Мои неправильные ответы',
                        wrongs_desc: 'Список ваших ошибок в тестах ПДД. Повторите сложные вопросы и закрепите правильные ответы.',
                        categories_title: 'Вопросы ПДД по темам - Категории',
                        categories_desc: 'Изучайте ПДД Армении по конкретным темам: перекрестки, знаки, медицина, эксплуатация и другие.',
                        learn_title: 'Изучение правил дорожного движения - Справочник',
                        learn_desc: 'Самые важные выдержки из правил дорожного движения Армении для легкой подготовки к экзамену.',
                        favorites_title: 'Избранные вопросы ПДД',
                        favorites_desc: 'Ваш список сохраненных вопросов для быстрого повторения перед экзаменом.',
                        about: 'О нас',
                        privacy: 'Конфиденциальность',
                        terms: 'Условия',
                        created_by: 'Создано AvtoDas'
                    },
                    battle: {
                        mode_title: 'Quiz Battle Mode',
                        mode_desc: 'Соревнуйтесь с другими пользователями в реальном времени. Кто быстрее и правильнее ответит на те же вопросы.',
                        start_btn: 'НАЧАТЬ БИТВУ',
                        wins: 'Победы',
                        points: 'Баллы',
                        searching: 'Ищем соперника...',
                        searching_desc: 'Приготовьтесь, соревнование скоро начнется',
                        cancel: 'Отмена',
                        you: 'Вы',
                        waiting_opponent: 'Ждем соперника...',
                        waiting_desc: 'Вы закончили, посмотрим как ответит соперник',
                        victory: 'Победа!',
                        victory_desc: 'Вы превзошли своего соперника',
                        draw: 'Ничья',
                        draw_desc: 'Вы оба равны',
                        defeat: 'Поражение',
                        defeat_desc: 'В этот раз удача была не на вашей стороне',
                        your_score: 'Ваши баллы',
                        opponent_score: 'Баллы соперника',
                        play_again: 'Играть снова',
                        back_home: 'На главную',
                        opponent_left_title: 'Соперник ушел',
                        opponent_left_desc: 'Вы выиграли технической победой!',
                        your_wins: 'Ваши победы'
                    }
                }
            },
            hy: {
                translation: {
                    header:{
                        home:'Գլխավոր',
                        tests:'Թեստեր',
                        wrongs:'Սխալ պատասխաններ',
                        grouped_questions:'Կատեգորիաներ',
                        learn_rules: 'Կանոնների ուսուցում',
                        traffic_signs: 'Ճանապարհային նշաններ',
                        favorites: 'Նախընտրելի հարցեր',
                        psycho: 'Հոգեբանական թեստեր',
                        search: 'Փնտրել հարց',
                        search_placeholder: 'Փնտրել հարց...',
                        educational: 'Ուսումնական',
                        my_results: 'Իմ արդյունքները',
                        exam_tests: 'Քննական թեստեր',
                        answer_title: 'Հարցի պատասխան'
                    },
                    home:{
                        welcome_text:'Բարի գալուստ AvtoDas.am',
                        description:"AvtoDas.am -ում ներառված են վարորդական իրավունք ստանալու տեսական քննության բոլոր հարցերը՝ բոլորովին անվճար։ Այստեղ Դուք կարող եք ծանոթանալ թեստերի հետ, պատասխանել տրված հարցերին , այնուհետև տեսնելով արդյունքները, կրկին պատասխանել սխալ պատասխանված հարցերին,որը կօգնի ամրապնդել ճիշտ պատասխանները։ Կայքում կան նաև խմբավորված հարցերի ցանկ՝ ըստ թեմաների։ Թեստերը անցնելուց հետո հատուկ ուշադրություն դարձրեք տրված բացատրություններին ։",
                        results:"Արդյունքների ամփոփում",
                        questions_count:'Հարցերի քանակը',
                        answered:'Փորձել եք պատասխանել',
                        true_answers:'Ճիշտ պատասխաններ',
                        wrong_answers:'Սխալ պատասխաններ',
                        answer:'Պատասխանել',
                        not_answered:'Չպատասխանված հարցեր',
                        see_answer_end:'Տեսնել արդյունքը վերջում',
                        see_answer_end_desc:'Հարցը պատասխանելուց հետո ավտոմատ անցնել մյուսին և արդյունքները տեսնել վերջում',
                        site_lang:'Կայքի լեզուն',
                        settings:'Կարգավորումներ',
                        learn_rules_title: 'Սովորեք ամենակարևոր կանոնները',
                        learn_rules_desc: 'Մենք առանձնացրել ենք ճանապարհային երթևեկության ամենակարևոր կանոնները, որոնք կօգնեն ձեզ ավելի հեշտ հանձնել քննությունը և դառնալ հմուտ վարորդ:',
                        start_learning: 'Սկսել ուսուցումը',
                        next_quiz: 'Հաջորդ թեստը',
                        continue_quiz: 'Շարունակել թեստ №{{number}}',
                        progress: 'Ձեր առաջընթացը',
                        passed_quizzes: 'Անցած թեստերը',
                        no_passed_quizzes: 'Դուք դեռ ոչ մի թեստ չեք անցել:',
                        hello: 'Բարև',
                        years_old: 'տարեկան',
                        change_info: 'Փոխել տվյալները',
                        faq_title: 'Հաճախ տրվող հարցեր (FAQ)',
                        contact_us: 'Հետադարձ կապ:',
                        clear: 'Մաքրել',
                        clear_wrongs_title: 'Սխալ պատասխաններ',
                        clear_wrongs_desc: 'Մաքրել բոլոր սխալ պատասխանները',
                        clear_results_title: 'Մաքրել արդյունքները',
                        clear_results_desc: 'Մաքրել բոլոր պատասխանված թեստերի արդյունքները',
                        confirm_clear_wrongs: 'Բոլոր սխալ պատասխանները կհամարվեն ճիշտ վստահ եք?',
                        confirm_clear_results: 'Բոլոր արդյունքները կմաքրվեն վստահ եք?',
                        yes: 'Այո',
                        no: 'Ոչ',
                        about: 'Մեր մասին',
                        privacy: 'Գաղտնիություն',
                        terms: 'Պայմաններ',
                        created_by: 'Ստեղծված է AvtoDas-ի կողմից',
                        wall_of_fame: 'Պատվո տախտակ',
                        recently_passed: 'Վերջերս հանձնածներ',
                        passed_with_score: 'Հանձնել է {{score}}/20 արդյունքով'
                    },
                    wrongs:{
                        desc_1:'Այստեղ կարող եք լուծել ձեր սխալ պատասխանած հարցերը',
                        desc_2:'Սխալ պատասխաններ - {{count}}',
                        clear_all_confirm: 'Մաքրել բոլոր սխալները?',
                        clear_all_btn: 'Մաքրել բոլորը',
                        shuffle: 'Խառնել',
                        loading: 'Բեռնվում է...',
                        congrats_no_wrongs: 'Շնորհավորում ենք:',
                        no_wrongs_desc: 'Դուք չունեք սխալ պատասխանած հարցեր: Դուք պատրաստ եք քննությանը:',
                        random_question: 'Պատահական հարց'
                    },
                    questions:{
                        see_description:'Դիտել բացատրությունը',
                        next:'Հաջորդը',
                        tests:'Հարցաշար',
                        true_answers_count:'Ճիշտ պատասխանների քանակը {{count}}/20',
                        difficulty:'Բարդությունը',
                        congrats: 'Շնորհավորում ենք:',
                        try_again: 'Փորձել նորից',
                        passed_desc: 'Դուք հաջողությամբ անցաք այս թեստը:',
                        failed_desc: 'Ցավոք, դուք չանցաք թեստը: Անհրաժեշտ է առնվազն 18 ճիշտ պատասխան:',
                        back_to_list: 'Վերադառնալ ցանկին',
                        review_answers: 'Ստուգել պատասխանները',
                        suggest_description: 'Առաջարկել նոր բացատրություն',
                        write_armenian_letters: 'Բացատրությունը գրել հայատառ',
                        dont_forget_nation: 'Որպեսզի ազգը ձեզ չմոռանա!!!',
                        description_label: 'Բացատրություն',
                        field_required: 'Դաշտը պարտադիր է լրացման համար',
                        suggestion_success: 'Ձեր գրառումը կստուգվի ադմինիստրատորի կողմից և կավելացվի ԱԶԳԸ ՁԵԶ ՉԻ ՄՈռԱՆԱ',
                        remove_favorites: 'Հեռացնել նախընտրելիներից',
                        add_favorites: 'Ավելացնել նախընտրելիներում'
                    },
                    search: {
                        found_count: 'Գտնվել է {{count}} հարց',
                        not_found: 'Հարցեր չեն գտնվել:'
                    },
                    comments: {
                        title: 'Մեկնաբանություններ',
                        name: 'Ձեր անունը',
                        content: 'Ձեր մեկնաբանությունը',
                        submit: 'Ուղարկել',
                        placeholder_name: 'Մուտքագրեք ձեր անունը',
                        placeholder_content: 'Գրեք մեկնաբանություն...',
                        success: 'Ձեր մեկնաբանությունը հաջողությամբ ավելացվեց:',
                        error_duplicate: 'Դուք արդեն ուղարկել եք այս մեկնաբանությունը:',
                        error_spam: 'Խնդրում ենք սպասել նոր մեկնաբանություն ուղարկելուց առաջ:',
                    },
                    quiz_filter: {
                        all: 'Բոլորը',
                        passed: 'Անցած',
                        failed: 'Չանցած',
                        not_started: 'Չսկսած',
                        new: 'Նոր',
                    },
                    categories: {
                        questions_count: 'Հարցերի քանակը: {{count}}',
                        description: 'Ուսումնասիրեք հարցերը ըստ կոնկրետ թեմաների՝ ձեր գիտելիքները ամրապնդելու համար'
                    },
                    seo: {
                        home_title: 'AvtoDas - Վարորդական տեսական քննությունների թեստեր 2026',
                        home_desc: 'Անվճար օնլայն թեստեր վարորդական իրավունք ստանալու համար։ Բոլոր 1200 հարցերը բացատրություններով, ճանապարհային նշանների և կանոնների ուսուցում։',
                        quizes_title: 'Բոլոր տեսական թեստերի ցանկը - AvtoDas',
                        quizes_desc: 'Վարորդական քննության բոլոր 60 տոմսերը։ Պատրաստվեք քննությանը անվճար և արդյունավետ։',
                        quiz_title: 'Թեստ №{{number}} - Վարորդական տեսական քննություն',
                        quiz_desc: 'Անցեք օնլայն թեստ №{{number}}-ը վարորդական քննությանը պատրաստվելու համար։ Ստուգեք ձեր գիտելիքները հիմա։',
                        wrongs_title: 'Սխալ պատասխանների ուղղում - Իմ սխալները',
                        wrongs_desc: 'Ձեր սխալ պատասխանած հարցերի ցանկը։ Կրկնեք բարդ հարցերը և ամրապնդեք ձեր գիտելիքները։',
                        categories_title: 'Հարցեր ըստ թեմաների - Խմբավորված հարցեր',
                        categories_desc: 'Ուսումնասիրեք ճանապարհային երթևեկության կանոնները ըստ թեմաների՝ խաչմերուկներ, նշաններ, բուժօգնություն և այլն։',
                        learn_title: 'Ճանապարհային երթևեկության կանոնների ուսուցում',
                        learn_desc: 'Ամենակարևոր կանոնները և բացատրությունները վարորդական քննությունը հեշտ հանձնելու համար։',
                        favorites_title: 'Նախընտրելի հարցերի ցանկ',
                        favorites_desc: 'Ձեր կողմից առանձնացված կարևոր հարցերը արագ կրկնելու և սովորելու համար։',
                        about: 'Մեր մասին',
                        privacy: 'Գաղտնիություն',
                        terms: 'Պայմաններ',
                        created_by: 'Ստեղծված է AvtoDas-ի կողմից'
                    },
                    battle: {
                        mode_title: 'Quiz Battle Mode',
                        mode_desc: 'Մրցեք այլ օգտատերերի հետ իրական ժամանակում: Ով ավելի արագ և ճիշտ կպատասխանի նույն հարցերին:',
                        start_btn: 'ՍԿՍԵԼ ՄՐՑՈՒՅԹԸ',
                        wins: 'Հաղթանակներ',
                        points: 'Միավորներ',
                        searching: 'Փնտրում ենք մրցակից...',
                        searching_desc: 'Պատրաստվեք, մրցույթը շուտով կսկսվի',
                        cancel: 'Չեղարկել',
                        you: 'Դուք',
                        waiting_opponent: 'Սպասում ենք մրցակցին...',
                        waiting_desc: 'Դուք ավարտել եք, տեսնենք ինչպես կպատասխանի մրցակիցը',
                        victory: 'Հաղթանակ!',
                        victory_desc: 'Դուք գերազանցեցիք ձեր մրցակցին',
                        draw: 'Ոչ-ոքի',
                        draw_desc: 'Երկուսդ էլ հավասար եք',
                        defeat: 'Պարտություն',
                        defeat_desc: 'Այս անգամ բախտը ձեր կողմից չէր',
                        your_score: 'Ձեր միավորները',
                        opponent_score: 'Մրցակցի միավորները',
                        play_again: 'Նորից խաղալ',
                        back_home: 'Գլխավոր էջ',
                        opponent_left_title: 'Մրցակիցը դուրս եկավ',
                        opponent_left_desc: 'Դուք հաղթեցիք տեխնիկական հաղթանակով:',
                        your_wins: 'Ձեր հաղթանակները'
                    }
                }
            },
        }
    });

export default i18n;